"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRowHideCellMarkDestination = void 0;
var tslib_1 = require("tslib");
var table_row_property_descriptor_1 = require("../../../../../../core/model/tables/properties/table-row-property-descriptor");
var table_row_properties_leaf_element_destination_1 = require("./table-row-properties-leaf-element-destination");
var TableRowHideCellMarkDestination = (function (_super) {
    tslib_1.__extends(TableRowHideCellMarkDestination, _super);
    function TableRowHideCellMarkDestination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableRowHideCellMarkDestination.prototype.processElementClose = function (reader) {
        this.row.properties.setValue(table_row_property_descriptor_1.TableRowPropertyDescriptor.hideCellMark, this.data.readerHelper.getWpSTOnOffValue(reader, 'val'));
    };
    return TableRowHideCellMarkDestination;
}(table_row_properties_leaf_element_destination_1.TableRowPropertiesLeafElementDestination));
exports.TableRowHideCellMarkDestination = TableRowHideCellMarkDestination;
